<template>

  <div class="card modal-card">
    <header class="card-header modal-card-header-title">
      <div class="card-header-title modal-card-header-title">
        <p class="card-title modal-card-title" v-if="action == 'EDIT'">{{$t('RouteModal.edit')}} {{this.route.name}}</p>
        <p class="card-title modal-card-title" v-if="action == 'CREATE'">{{$t('RouteModal.create_new_route')}}</p>
      </div>
      <a @click="$parent.close()" class="card-header-icon" aria-label="more options">
        <b-icon icon="close" type="is-white"></b-icon>
      </a>
    </header>
    <section class="card-content">
      <div class="columns is-centered">
        <div class="column is-12">
          <b-field
            :label="$t('RouteModal.name')"
            :type="{'is-danger': errors.has('name')}"
            :message="errors.first('name')"
          >
            <b-input
              maxlength="10"
              v-validate="'required'"
              v-model="form.name"
              name="name"
              ref="name"
              :placeholder="$t('RouteModal.name_ph')"
            ></b-input>
          </b-field>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-6">
          <b-field :label="$t('RouteModal.driver_name')">
            <b-input v-model="form.driverName" :placeholder="$t('RouteModal.driver_name_ph')"></b-input>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field :label="$t('RouteModal.vehicle')">
            <b-select :placeholder="$t('RouteModal.vehicle_ph')" expanded v-model="form.vehicle">
              <option
                v-for="vehicle in vehicles"
                :key="vehicle.id"
                :value="vehicle"
              >{{ vehicle.vehicleRegistration }}</option>
            </b-select>
          </b-field>
        </div>
      </div>

      <div class="columns is-centered">
        <div class="column is-12">
          <b-field :label="$t('RouteModal.departure_time')">
            <b-timepicker
              v-model="form.departureTime"
              :placeholder="$t('RouteModal.departure_time_ph')"
            ></b-timepicker>
          </b-field>
          <b-field :label="$t('RouteModal.route_tags')">
            <b-taginput
              v-model="form.tags"
              maxlength="20"
              :placeholder="$t('RouteModal.route_tags_ph')"
            ></b-taginput>
          </b-field>

          <b-field :label="$t('RouteModal.comment')">
            <b-input
              v-model="form.comments"
              type="textarea"
              maxlength="150"
              rows="2"
              :placeholder="$t('RouteModal.comment_ph')"
            ></b-input>
          </b-field>
        </div>
      </div>
    </section>
    <footer class="card-footer">
      <div class="card-footer-item">
        <button class="button is-danger" v-if="action == 'EDIT'" @click="deleteRoute()">{{$t('RouteModal.action_delete')}}</button>&nbsp;
        <button
          class="button is-primary"
          v-if="action == 'EDIT'"
          @click="updateRoute()"
        >{{$t('RouteModal.action_update')}}</button>
        <button class="button is-primary" v-if="action == 'CREATE'" @click="createRoute()">{{$t('RouteModal.action_save')}}</button>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RouteModal',

  beforeCreate () {
    this.$log.info('Request all vehicles...')
    this.$store.dispatch('planning/retrieveAllVehicles')
  },

  mounted () {
    this.$refs.name.focus()
  },

  data: function () {
    return {
      isOpen: false,
      vehicle: {
        vehicleRegistration: '',
        trolleyCapacity: 0,
        maxWeight: 0.0,
        comments: ''
      },
      form: {
        name: this.route.name,
        driverName: this.route.driverName,
        departureTime: this.formatHour(this.route.departureHour),
        vehicle: this.route.vehicle,
        tags: this.route.tags,
        comments: this.route.comments
      }
    }
  },
  props: {
    planningId: { type: Number, required: true },
    route: {
      type: Object,
      default: () => ({
        name: '',
        driverName: '',
        departureHour: 0,
        tags: [],
        comments: ''
      })
    },
    action: { type: String, required: true }
  },

  computed: {
    ...mapGetters('planning', ['vehicles'])
  },

  methods: {

    addVehicle: function () {
      if (this.vehicle.vehicleRegistration && this.vehicle.vehicleRegistration.trim() !== '') {
        this.$store.dispatch('planning/addVehicle', this.vehicle)
      }
    },
    /**
     * Departure hour / 60 must be between 0 and 24
     */
    formatHour: function (departureHour) {
      const date = new Date()
      if (departureHour) {
        const hours = departureHour / 60
        const minutes = departureHour % 60
        date.setHours(hours)
        date.setMinutes(minutes)
      }
      return date
    },

    createRoute: function () {
      this.$validator.validate().then(valid => {
        if (valid) {
          const route = {}
          route.name = this.form.name
          route.driverName = this.form.driverName
          route.departureHour = this.form.departureTime.getHours() * 60 + this.form.departureTime.getMinutes()
          route.vehicle = this.form.vehicle
          route.tags = this.form.tags
          route.comments = this.form.comments
          route.active = true

          this.$store.dispatch('planning/addRouteToPlanning', [this.planningId, route])
          this.$parent.close()
        }
      })
    },

    updateRoute: function () {
      this.$validator.validate().then(valid => {
        if (valid) {
          const route = this.route
          route.name = this.form.name
          route.driverName = this.form.driverName
          route.departureHour = this.form.departureTime.getHours() * 60 + this.form.departureTime.getMinutes()
          route.vehicle = this.form.vehicle
          route.tags = this.form.tags
          route.comments = this.form.comments

          this.$store.dispatch('planning/updateRouteForPlanning', [this.planningId, route])
          this.$parent.close()
        }
      })
    },

    deleteRoute: function () {
      this.$store.dispatch('planning/deleteRouteForPlanning', [this.planningId, this.route.id])
      this.$parent.close()
    }
  }
}
</script>

<style>
.card-header {
  background-color: #448993;
}
.modal-content {
  overflow: unset !important;
}
.modal-card-header-title {
  border-radius: 3px 3px 0px 0px !important;
}
.modal-card-title {
  color: white !important;
  font-size: 20px !important;
  font-weight: initial !important;
}
.modal-card {
  overflow: auto;
  width: auto;
  border-radius: 3px !important;
}
.modal .modal-content {
  width: 640px;
}
</style>
